import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { useDispatch, useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min'

import DashboardComponent from '../../components/DashboardComponent'
import UploadComponent from '../../components/UploadComponent'
import AssignVendorComponent from '../../components/AssignVendorComponent'
import DomainComponent from '../../components/DomainComponent'
import MainLayout from '../../layout/MainLayout'
import QualityComponent from '../../components/QualityComponent'
import UserManageComponent from '../../components/UserManageComponent'
import MyListsComponent from '../../components/MyListsComponent'
import FuseJsTestComponent from '../../components/FuseJsTestComponent'
import { checkIsAdminOrModerator } from '../../services/helper'
import CallerSettings from '../../components/CallerSettingsComponent'
import { UPDATE_SUPPLIERS_SEARCH_LIST, UPDATE_SUPPLIERS_SEARCH_RESULTS } from '../../redux/actionTypes/vendor'
import CustomReport from '../../components/Report/customReport'
import ThresholdSettings from '../../components/ThresholdSettingComponent'
import CreateContact from '../../components/ContactsComponent/createContact'
import UserSettings from '../../components/UserSettings'
import EmailManagement from '../../components/EmailManagement'
import Tasks from '../../components/Tasks/index'
import Settings from "../Settings/index"
import { AppContext } from '../../context'

const DashboardPage = () => {
  const store = useStore().getState()
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    domain: {
      currentDomain,
    }
  } = store



  const isAdminOrModerator = checkIsAdminOrModerator(currentDomain)

  history.listen((location, action) => {
    if (!location.pathname?.includes('suppliers')) {
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_LIST,
        data: {}
      })
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_RESULTS,
        data: {
          masters: {},
          childs: {},
          locationMasters: {}
        }
      })
    }
  });
  let params = useParams()

  return (
    <MainLayout>
      <Switch>
        <Route path='/emailAuthToken/:authToken' />
        <Route path='/dashboard' component={DashboardComponent} />
        <Route path='/upload' component={UploadComponent} />
        <Route path='/suppliers' component={AssignVendorComponent} />
        <Route path='/suppliers/:masterId' component={AssignVendorComponent} />
        <Route path='/domain' component={DomainComponent} />
        <Route path='/qa' component={QualityComponent} />
        <Route path='/qa/:masterId' component={QualityComponent} />
        <Route path='/user-manage' component={UserManageComponent} />
        <Route path='/suppliers/relatedsupplier/:relatedSupplierId' component={AssignVendorComponent} />
        <Route path='/qa/relatedsupplier/:relatedSupplierId' component={QualityComponent} />
        <Route path='/lists' component={MyListsComponent} />
        <Route path="/report" component={CustomReport} />
        <Route path="/report/:reportId" component={CustomReport} />
        <Route path="/reports" component={CustomReport} />
        <Route path='/contacts/:contactId' component={CreateContact} />
        {currentDomain?.roleId === 3 && currentDomain?.roleName === 'admin' &&
          <Route path='/test' component={FuseJsTestComponent} />
        }
        <Route path='/settings' component={Settings} />
        <Route path='/caller-settings' component={CallerSettings} />
        <Route path='/matching-threshold-settings' component={ThresholdSettings} />
        <Route path='/user-settings' component={UserSettings} />
        <Route path='/sent-emails' component={EmailManagement} />
        <Route path='/tasks' component={Tasks} />
      </Switch>
    </MainLayout>
  );
}

export default DashboardPage
